import * as React from "react";
import { LogNodeModel } from "../../../models/logNodeModel";
import LogFilesView from './logFilesView';
import LogFileService from '../../../services/logFileService';
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Spinner from '../../../common/components/spinner/spinner';
import Loadable from 'react-loadable';
import { TreeNodeModel } from '../../../models/treeNodeModel';
import { Button } from 'primereact/button';
import { Growl } from 'primereact/growl';
import { ContextMenu } from 'primereact/contextmenu';
import { AtcCodeContentModel } from '../../../models/atcCode/atcCodeContentModel';
import { Lang } from '../../../common/enums';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import { Toolbar } from 'primereact/toolbar';
import { BrowserRouter, Route, Link, Switch, Redirect } from "react-router-dom";
import FileSaver from 'file-saver';

interface IProps {
}

interface IState {
  listLogNodes: Array<LogNodeModel>;
  treeLogNodes: Array<TreeNodeModel>;
  isLoading: boolean;
  error: any;
  validationMessage: string;
  isVisibleDialog: boolean;
  isVisibleDialogWrap: boolean;
  isVisibleConfirmDialog: boolean;
  selectionKeys: any;
  selectedLogNodeIds: Array<string>;
  contextMenu: any;
  currentFileLogNode: LogNodeModel;
  lastFileLogNode: LogNodeModel;
}

class LogFilesContainer extends React.Component<IProps, IState> {
  logFileService = new LogFileService();
  messages: any;
  growl: any;
  cm: any;

  constructor(props: IProps) {
    super(props);

    const menu = [
      {
        label: 'View',
        icon: 'pi pi-pencil',
        command: () => { this.handleViewClick(this.state.selectionKeys) }
      }
    ];

    this.state = {
      error: null,
      validationMessage: '',
      listLogNodes: new Array<LogNodeModel>(0),
      treeLogNodes: new Array<TreeNodeModel>(0),
      isLoading: false,
      isVisibleDialog: false,
      isVisibleDialogWrap: false,
      isVisibleConfirmDialog: false,
      selectionKeys: null,
      selectedLogNodeIds: new Array<string>(0),
      contextMenu: menu,
      currentFileLogNode: new LogNodeModel(),
      lastFileLogNode: new LogNodeModel()
    };
  }

  // events
  componentDidMount() {
    this.getAllLogNodes();
  }

  handleViewClick = id => {
    this.setState({
      isLoading: true
    });

    let logNode = this.state.listLogNodes.find(n => n.itemId == id);

    if (logNode && logNode.nodeType === 'Archive') {
      this.logFileService.getLogFileData(logNode)
        .then(
          (data) => {
            let res = new Blob([data], { type: 'application/json' });
            //let fileURL = URL.createObjectURL(res);

            FileSaver.saveAs(res, logNode ? logNode.name : "undefined.log");

            // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // window.navigator.msSaveOrOpenBlob(res);
            // }
            // else{
            //   window.open(fileURL, '_blank');
            // }

            this.setState({
              isLoading: false
            });
          },
          error => {
            this.setState({
              error,
              isLoading: false
            });
          }
        );
    }
    else {
      this.setState({
        error: { message: 'Can not view directories!' },
        isLoading: false
      });
    }
  };

  handleSelectionChange = (value) => {
    let logNodeIds = new Array<string>(0);
    logNodeIds.push(value);

    this.setState({
      selectionKeys: value,
      selectedLogNodeIds: logNodeIds.slice()
    });

    let currentNode = this.state.listLogNodes.find(n => n.itemId == value);
    if (currentNode && currentNode.nodeType === 'Archive') {
      this.setCurrentLogNode(currentNode);
    } else {
      this.setCurrentLogNode(new LogNodeModel());
    }
  }

  setCurrentLogNode(logNode: LogNodeModel) {
    this.setState({ currentFileLogNode: { ...logNode } });
  }


  // methods
  getAllLogNodes() {
    this.setState({
      isLoading: true
    });

    this.logFileService.getAllNodes().then(
      (data: Array<LogNodeModel>) => {
        this.setState({
          isLoading: false,
          listLogNodes: data
        });
        this.createTree();
        this.setLastLogFile()
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  setLastLogFile() {
    let sortedFileNodes = this.state.listLogNodes.filter(i => i.nodeType == "Archive" && i.fullPath.includes('AppLog')).sort(function (a, b) {
      var fileNameA = a.name.toLowerCase(), fileNameB = b.name.toLowerCase();
      if (fileNameA < fileNameB) return -1;
      if (fileNameA > fileNameB) return 1;
      return 0;
    });

    if (sortedFileNodes && sortedFileNodes.length > 0) {
      let lastFileNode = sortedFileNodes[sortedFileNodes.length - 1];
      this.setState({ lastFileLogNode: lastFileNode });
    }
  }

  createTree() {
    let subTree = this.createSubTree(null);
    this.setState({
      treeLogNodes: subTree
    });
  }

  createSubTree(parentItemId) {
    let subTree = new Array<TreeNodeModel>(0);

    this.state.listLogNodes
      .filter(f => parentItemId ? f.parentItemId == parentItemId : f.parentItemId == null)
      .sort((a, b) => (a.orderNo > b.orderNo) ? 1 : (b.orderNo > a.orderNo ? -1 : 0))
      .map(f => {
        let node = new TreeNodeModel();
        node.key = f.itemId;

        if (f.nodeType === "Directory") {
          node.label = f.name
        }
        else {
          node.label = f.name + " (" + HelperFunctions.formatBytes(f.fileSizeInBytes, 1) + ")";
        }

        //node.label = f.name + " (" + HelperFunctions.formatBytes(f.fileSizeInBytes, 3) + ")";
        node.data = { ...f };
        node.icon = f.nodeType === "Directory" ? "pi pi-folder" : "pi pi-file";
        if (this.state.listLogNodes.some(a => a.parentItemId == f.itemId)) {
          node.children = this.createSubTree(f.itemId);
        };
        subTree.push(node);
      });

    return subTree;
  }

  public render() {

    const { treeLogNodes, isLoading, error, selectionKeys, selectedLogNodeIds, currentFileLogNode, lastFileLogNode } = this.state;

    let lastLogElement: any = null;
    if (lastFileLogNode) {
      lastLogElement =
        <Button
          label={"View last" + " - " + lastFileLogNode.name}
          className="p-button-success"
          onClick={() => this.handleViewClick(lastFileLogNode.itemId)}
        />
    } else {
      lastLogElement =
        <Button
          label="No log files detected"
          className="p-button-success"
          disabled={true}
        />
    }

    let currentLogElement: any = null;
    if (currentFileLogNode && currentFileLogNode.name) {
      currentLogElement =
        <Button
          style={{ marginLeft: "10px" }}
          label={"View current" + " - " + currentFileLogNode.name}
          className="p-button-info"
          onClick={() => this.handleViewClick(currentFileLogNode.itemId)}
        />
    } else {
      currentLogElement =
        <Button
          style={{ marginLeft: "10px" }}
          label="No log file selected"
          className="p-button-info"
          disabled={true}
        />
    }

    return (
      <div>
        <h3>Logs</h3>
        {isLoading ? <Spinner /> : null}
        {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}
        <Growl ref={(el) => this.growl = el} />

        <Toolbar style={{ marginTop: '10px', marginBottom: '10px' }}>
          <div style={{ marginTop: "10px", marginBottom: '10px' }}>
            {lastLogElement}
            {currentLogElement}
          </div>
        </Toolbar>

        <ContextMenu model={this.state.contextMenu} ref={el => this.cm = el} />

        <LogFilesView
          treeLogNodes={treeLogNodes}
          selectionKeys={selectionKeys}
          handleSelectionChange={this.handleSelectionChange}
          onContextMenu={event => (selectedLogNodeIds && selectedLogNodeIds.length > 0 ? this.cm.show(event.originalEvent) : null)}
        />
      </div>
    );
  }
}

export default LogFilesContainer;